/**
 * ActiveClosedPill.jsx - "is this won job still running?"
 *
 * projectStatus() turns the single rule (isClosedProject in
 * src/data/projectStatus.js, projects.closed) into the pill's label,
 * exported next to the pill that renders it so the two can never disagree.
 */
import ConfirmDeleteModal from '../shared/ConfirmDeleteModal';
import { isClosedProject } from '../../data/projectStatus';

/* Leadership terminology: a project is "Closed" when its closed flag is
   set; everything else is "Active". Replaces the old Won/Open/Lost chips. */
// Case-insensitive: the stored data has both "YES" and "Yes", and the edit form
// normalises on load, so a stricter test here would show one state in the table
// and another in the form. The sidebar Projects badge and the Dashboard's Active
// Projects card use the same isClosedProject, so all of them agree.
export const projectStatus = (p) => (isClosedProject(p) ? 'Closed' : 'Active');

function ActiveClosedPill({ value }) {
  const active = value === 'Active';
  return (
    <span
      style={{
        display: 'inline-block',
        padding: '2px 10px',
        borderRadius: 10,
        fontSize: 9.5,
        fontWeight: 700,
        fontFamily: "'Montserrat', sans-serif",
        background: active ? '#1B5E20' : '#8E1B1B',
        color: '#fff',
        border: `1px solid ${active ? '#124116' : '#6E1414'}`,
      }}
    >
      {value}
    </span>
  );
}

/* Delete confirmation now lives in components/shared/ConfirmDeleteModal (the
   same dialog + server-rules warning is used by Opportunities). */

// Module-scope wrappers pin this view's Th/Td variant (denser px-3 padding +
// amber-aware header) once, so every call site below renders byte-identically
// to the old local copies. Module scope keeps component identity stable —
// never define these inside a render body.
// `sticky` keeps the column headings visible while the table scrolls (see the
// scroll-pane comment on the table wrapper for why the pane, not the page,
export default ActiveClosedPill;
